module.exports = __webpack_public_path__ + "img/product13.ee243137.png";